<!--
===========================================================================
  Tibia Calcs GPL Source Code
  Copyright (C) 2020 Lucas Soares de Miranda
  Copyright (C) 2020 Luiz Claudio Soares de Miranda

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <http://www.gnu.org/licenses/>.

  License available on https://github.com/lucasoares/tibia-calcs/blob/main/LICENSE.md
===========================================================================
-->

<template>
  <div class="imbuement">
    <h1 id="main-title">
      Top Guild Xp World
    </h1>

    <v-container class="calculator">
      <v-row no-gutters>
        <v-col cols="4">
          <h3>World Selector</h3>

          <v-row>
            <v-col>
              <v-autocomplete class="imbuement-selector" :items="getWorlds()" label="World" v-model="selected"
                item-value="id" v-on:change="showWorldXp()"></v-autocomplete>
            </v-col>
          </v-row>

          <!-- <h3>{{ worldXp }}</h3> -->
        </v-col>
        <v-col cols="8">
          <h3>Top Guilds Xp</h3>
          <v-row>
            <v-col>
              <v-simple-table>
                <template v-slot:default>
                  <thead>

                    <tr>
                      <th class="text-left">
                        Name
                      </th>
                      <th v-for="column in   columns " :key="column" class="text-left">
                        <a href="#" v-on:click="sortBy(column)" class="sort-by"
                          :class="{ active: sortKey === column, headerSortDown: reverse, headerSortUp: !reverse }">
                          {{ column }}
                        </a>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="( item ) in  worldXp " :key="item.name">
                      <td>{{ item.name }}</td>
                      <td>{{ item.day }}</td>
                      <td>{{ item.week }}</td>
                      <td>{{ item.month }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <div class="ad-container">
      <Adsense style="text-align:center;" data-ad-client="ca-pub-1611927435750729" data-ad-slot="7936683191"
        data-ad-format="auto">
      </Adsense>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Top Guild Xp World',
  data: () => ({
    selected: '',
    items: [''],
    guilds: {},
    worldXp: [],
    columns: ['Day', 'Week', 'Month'],
    sortKey: 'Day',
    reverse: false,
  }),

  computed: {
    ...mapGetters('TopGuildXp', { state: 'getState' }),

  },
  methods: {
    ...mapActions('TopGuildXp', ['updateSelected']),
    ...mapGetters('TopGuildXp', { getWorld: 'getWorld', getGuilds: 'getGuilds' }),
    sortBy(sortKey) {
      const lowSortKey = sortKey.toLowerCase();
      this.reverse = (this.sortKey === sortKey) ? !this.reverse : false;

      this.worldXp = this.worldXp.sort((a, b) => {
        const aa = Number(a[lowSortKey].replace(/,/g, ''));
        const bb = Number(b[lowSortKey].replace(/,/g, ''));

        console.log(aa, bb);
        if (this.reverse) {
          return aa > bb ? 1 : -1;
        }
        return aa > bb ? -1 : 1;
      });

      this.sortKey = sortKey;
    },
    getWorlds() {
      this.getWorld().then((response) => {
        this.items = response;
      });
      return this.items;
    },
    showWorldXp() {
      this.worldXp = [];
      this.updateSelected(this.selected);
      this.getGuilds().then((response) => {
        this.guilds = response;

        for (let i = 0; i < this.guilds.length; i += 1) {
          fetch(`https://tibia-token.azurewebsites.net/api/top-xp?guild=${this.guilds[i]}`)
            .then((r) => r.json())
            .then((data) => {
              this.worldXp.push(data);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.materials-divider {
  margin-bottom: 10px;
}

.material-price {
  margin-left: 5px;
}

.imbuements-results {
  padding: 0px 10% 0px 10%;
}

h1,
h3,
h4 {
  text-align: center;
}

.imbuement-selector {
  max-width: 80%;
}

.tier-select {
  max-width: 100px;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

a.active {
  font-weight: bold;
  color: black;
}

.active.headerSortDown:after,
.active.headerSortUp:after {
  content: ' ';
  position: relative;
  left: 6px;
  border: 8px solid transparent;
}

.active.headerSortDown:after {
  top: 10px;
  border-top-color: silver;
}

.active.headerSortUp:after {
  bottom: 15px;
  border-bottom-color: silver;
}

.active.headerSortDown,
.active.headerSortUp {
  padding-right: 10px;
}
</style>
